<template>
  <div>
    <modal id="edit-vendor-avatar">
      <template slot="header">Edit Vendor Avatar</template>
      <div class="card">
        <div class="card-body avatars-container">
          <div class="avatar-items d-flex flex-wrap p-0 mb-0">
            <div
              class="avatar-item col-4 col-sm-3 d-flex align-items-center justify-content-center"
              :class="{ selected: avatar.id == vendor.avatar_type }"
              v-tooltip.top="avatar.tooltip"
              v-for="avatar in vendorAvatars"
              :key="avatar.id"
            >
              <img
                class="avatar-img"
                :src="avatar.src"
                @click="selectAvatar(avatar.id)"
              />
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import constants from "../constants";

export default {
  name: "EditVendorAvatar",
  props: {
    vendor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedavatar: this.vendor.avatar_type,
      vendorAvatars: constants.AVATARS,
    };
  },

  methods: {
    selectAvatar: function (id) {
      this.vendor.avatar_type = id;
    },
  },
};
</script>

<style scoped lang="scss">
.avatars-container {
  max-height: 250px;
  overflow-y: auto;
}

.avatar-item {
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 24px;

  &.selected {
    border: 2px inset #5c6bc0;
  }
}

.avatar-img {
  cursor: pointer;
  max-width: 70px;
  max-height: 70px;
  width: 100%;
}
</style>
